<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="商品名称" outlined v-model="query.goodsName">
								</v-text-field>
							</div>
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
						
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn small @click="showAddDialog" color="info">库存调整</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				
				<template v-slot:item.masterImg="{item}">
					<v-avatar rounded class="my-1">
						<v-img v-if="item.masterImg" :src="imgPrev + item.masterImg" width="50" height="50"></v-img>
					</v-avatar>
				</template>
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 添加dialog -->
		<v-dialog title="调整库存" v-model="add.dialog" max-width="500">
			<v-card>
				<v-card-title>
					<span>库存调整</span>
					<v-spacer></v-spacer>
					<v-icon @click="add.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						
						<v-col cols="12">
							<v-select :items="selectGoodsList" v-model="add.stock.goodsId"
							item-text="goodsName" item-value="id" label="商品" dense outlined></v-select>
						</v-col>
						<v-col cols="12" class="mt-n5">
							<v-radio-group row v-model="add.stock.inOut" label="出入库类型:">
								<v-radio label="入库" value="1"></v-radio>
								<v-radio label="出库" value="2"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="6">
							<v-text-field label="交接人" v-model="add.stock.bizUserName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="数量" type="number" v-model="add.stock.quantity" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="备注" v-model="add.stock.memo" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddStock" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
    import global from '../../../config/global'
	export default {
		name: "goods-stock-list",
		data() {
			return {
				imgPrev: global.config.imgPre,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '商品库存管理',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '商品ID',
							value: 'goodsId',
							sortable: false
						},
						{
							text: '商品主图',
							value: 'masterImg',
							sortable: false
						},
						{
							text: '商品名称',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '库存数量',
							value: 'stock',
							sortable: false
						},
						
					],
					list: [],
				},
				selectGoodsList:[],
				query: {
					loading: false,
					page: 1,
					size: 20,
					goodsName: "",
				},
				add: {
					dialog: false,
					stock: {
						goodsId:"",
						shopId:"",
						inOut:"",
						quantity:"",
						bizUserName:"",
						memo:""
					},
				},

			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getGoodsListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			showAddDialog() {
				this.add.dialog = true;
			
	
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/goods/stock/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.goodsName) {
					url += "&goodsName=" + this.query.goodsName;
				}
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddStock() {
			
				// api
				const that = this;
				let url = `/erp/goods/stock/change`;
				let postData = {...this.add.stock};
				postData.shopId = this.shopId;
			

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
	
			getGoodsListForSelect(){
				const that = this;
				let url = `/erp/merchant/goods/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGoodsList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>

<style>
</style>
